import {
    Box,
    Paper,
    Typography,
    Grid,
    TextField,
    Button,
    List,
    ListItem,
    ListItemText,
    CircularProgress,
    IconButton,
    Divider,
    Alert
} from "@mui/material";
import { useEffect, useState } from "react";
import { useConfiguracoesEventosFinanceiro } from "../../../../../financeiro/hooks/useConfiguracoesEventosFinanceiro";
import { Add, Delete } from "@mui/icons-material";
import { IConfiguracaoEventoFinanceiro } from "../../../../../financeiro/interfaces/IConfiguracaoEventoFinanceiro";
import { useSnackbar } from "../../../../../core/contexts/SnackbarContext";

const EVENTO = 'ENVIO_NFCE_MENSAL';

export const ConfiguracaoRecebimentoNotaFiscal = () => {
    const [email, setEmail] = useState('');
    const [emailsCadastrados, setEmailsCadastrados] = useState<IConfiguracaoEventoFinanceiro[]>([]);
    const { listarConfiguracoes, criarConfiguracao, excluirConfiguracao, loading } = useConfiguracoesEventosFinanceiro();
    const notificar = useSnackbar();

    const validarEmail = (valor: string) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(valor);
    };

    const carregarEmails = async () => {
        const data = await listarConfiguracoes(EVENTO);
        if (Array.isArray(data)) {
            setEmailsCadastrados(data);
        }
    };

    const handleAdicionar = async () => {
        if (!validarEmail(email)) {
            notificar("E-mail inválido", { severity: 'error' })
            return;
        }

        const novo = await criarConfiguracao(email, EVENTO);
        if (novo) {
            carregarEmails();
            setEmail('');
        }
    };

    const handleExcluir = async (uuid: string) => {
        await excluirConfiguracao(uuid);
        await carregarEmails();
    };

    useEffect(() => {
        carregarEmails();
    }, []);

    return (
        <Paper sx={{ width: '100%', maxWidth: 800, mt: 4, p: { xs: 2, sm: 4 } }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: 'center' }}>
                <Typography variant="h6">E-mails de recebimento</Typography>
            </Box>

            <Grid container>
                <Alert severity="info" sx={{ mb: 2, mt: 2 }}>
                    Os e-mails configurados receberão automaticamente, no dia <strong>01 de cada mês</strong>, um arquivo ZIP contendo todos os <strong>XMLs das notas fiscais emitidas</strong>.
                    Isso facilita sua rotina e também a do seu contador!
                </Alert>
            </Grid>

            {loading ? (
                <Box sx={{
                    width: '100%',
                    height: '100px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <CircularProgress size={40} />
                </Box>
            ) : (
                <Grid container spacing={2} alignItems={'center'}>
                    <Grid item xs={12} sm={11}>
                        <TextField
                            label="E-mail"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            fullWidth
                            size="small"
                        />
                    </Grid>
                    <Grid item xs={12} sm={1}>
                        {loading ? (
                            <CircularProgress size={24} />
                        ) : (
                            <IconButton
                                onClick={handleAdicionar}
                                disabled={loading}
                                color="primary"
                            >
                                <Add />
                            </IconButton>
                        )}

                    </Grid>

                    {emailsCadastrados?.length ? (
                        <Grid item xs={12}>
                            <Paper variant="outlined">
                                <List>
                                    {emailsCadastrados.map((item, index) => (
                                        <Box key={item.uuid || index}>
                                            <ListItem
                                                secondaryAction={
                                                    <IconButton color="error" edge="end" onClick={() => handleExcluir(item.uuid)}>
                                                        <Delete />
                                                    </IconButton>
                                                }
                                            >
                                                <ListItemText primary={item.email} />
                                            </ListItem>
                                            {index < emailsCadastrados.length - 1 && <Divider />}
                                        </Box>
                                    ))}
                                </List>
                            </Paper>
                        </Grid>
                    ) : ''}
                </Grid>
            )}
        </Paper>
    );
};
